import * as React from 'react';
export var ThemeContext = React.createContext(undefined);